<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      :options="active ? activeLogisticsOption : logisticsOption"
      :placeholder="placeholder"
      :width="width"
  ></gj-select>
</template>

<script>
  import {mapGetters} from "vuex";
  import {
    LOGISTICS_GET_ACTIVE_LOGISTICS_OPTIONS, LOGISTICS_GET_LOGISTICS_OPTIONS,
  } from "../../store/action-types";

  export default {
    name: "gj-logistics-select",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '物流商'
      },
      width: {
        default: '150px',
      }
    },
    computed: {
      ...mapGetters(['logisticsOption', 'activeLogisticsOption']),
    },
    created() {
      if (this.active) {
        if (this._.isEmpty(this.activeLogisticsOption)) {
          this.$store.dispatch(LOGISTICS_GET_ACTIVE_LOGISTICS_OPTIONS);
        }
      } else {
        if (this._.isEmpty(this.logisticsOption)) {
          this.$store.dispatch(LOGISTICS_GET_LOGISTICS_OPTIONS);
        }
      }
    },
  }
</script>

<style scoped>

</style>
